import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { ProductBoxOneComponent } from "./product-box-one.component";
import { ProductBoxOnePipe } from "./product-box-one.pipe";

@NgModule ({

    declarations: [
        ProductBoxOneComponent,
        ProductBoxOnePipe
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule
    ],
    exports: [
        ProductBoxOneComponent
    ],
    providers: [
    ]

})

export class ProductBoxOneModule { };